export default [
  {
    path: '/protocol/yxm',
    name: 'protocolYxm',
    component: () => import('@/view/authentication/api-auth/protocols/yxm.vue')
  },
  // api授信相关协议
  {
    path: '/authentication/api-protocol', 
    component: () => import('@/view/authentication/api-auth/protocol'),
    name: 'apiAuthProtocol'
    // meta: { pageName: 'river_diversion_detail' }
  },
 
  // 提钱游协议 
  {
    path: '/protocol/api-tqy', 
    component: () => import('@/view/protocol/api-tqy'),
    name: 'apiAuthProtocolTqy'
    // meta: { pageName: 'river_diversion_detail' }
  },
  // r360协议
  {
    path: '/protocol/r-360/:mobile', 
    component: () => import('@/view/protocol/r-360'),
    name: 'protocolR360'
    // meta: { pageName: 'river_diversion_detail' }
  },
  // r360协议《个人信息使用授权书》
  {
    path: '/protocol/tmdr360', 
    component: () => import('@/view/protocol/tmdr360'),
    name: 'protocolR3602'
    // meta: { pageName: 'river_diversion_detail' }
  },
  {
    path: '/protocol/ddq',
    name: 'protocolDdq',
    component: () => import('@/view/authentication/api-auth/protocols/ddq.vue')
  },
  {
    path: '/protocol/qcs',
    name: 'protocolQcs',
    component: () => import('@/view/authentication/api-auth/protocols/qcs.vue')
  },  
  {
    path: '/protocol/monitor/instruction',
    name: 'monitorInstruction',
    component: () => import('@/view/protocol/monitor/instruction')
  },  
  {
    path: '/protocol/monitor/index',
    name: 'monitorIndex', // 强弹协议
    component: () => import('@/view/protocol/monitor/index')
  }
]